import React from 'react';
import { styled } from '@this/src/components/constants/themes';

type TravelModeType = 'jr' | 'air' | 'shin' | 'express' | 'evo_air' | string;
interface TravelModeIconProps {
  type: TravelModeType;
}

const TravelModeIcon = ({ type }: TravelModeIconProps) => {
  if (type === 'jr' || type === 'shin') {
    return <StyledImage src="/images/train.png" />;
  }

  if (type === 'air') {
    return <StyledImage src="/images/plane.png" />;
  }

  return null;
};

const StyledImage = styled.img`
  height: 20px;
  margin-left: 5px;
`;
export default TravelModeIcon;
